import { useEffect, useState } from "react";
import { FroalaEditor } from "../../../../../Components/CardsPages/Forms/Editor/FroalaEditor";
import UnForm from "../../../../../Components/Form";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEdit,
    faInfoCircle,
    faPaperPlane,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import {
    CadastrarTemplateMensagemAtivaController,
    EditarTemplateMensagemAtivaController,
    ObterTemplateMensagemAtivaController,
    RemoverVariavelMensagemAtivaController,
} from "../../../../../Controllers/HelpDesk/GestaoTemplate/GestaoTemplateController";
import {
    ICadastroTemplateMensagemAtiva,
    ILstVariaveistemplate,
} from "../../../../../Interfaces/HelpDesk/GestaoTemplate/GestaoTemplateInterace";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { useHistory, useParams } from "react-router-dom";
import { ACESSOS } from "../../../../../Routes/Acessos";
import Select from "react-select";
import { mockTemplateHelpdesk } from "./mockTemplateHelpdesk";
import Swal from "sweetalert2";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface htmlQuill {
    editorHtml: string;
}

interface URLParams {
    idDocumentoTemplate?: string;
}

interface IFile {
    name: string;
    data: Uint8Array;
}

export default function CadastrarEditarTemplateHelpdesk() {
    const FormMethods = useForm();
    const history = useHistory();

    const { idDocumentoTemplate } = useParams<URLParams>();

    const [uploading, setUploading] = useState(false);
    const [requiredMessage, setRequiredMessage] = useState(false);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [uploadedImages, setUploadedImages] = useState<string[]>([]);

    const [fileName, setFileName] = useState<string>();
    const [selectVariaveis, setSelectVariaveis] = useState<string[]>([]);
    const [valueTreeSelect, setValueTreeSelect] = useState<string[]>(
        Array(selectVariaveis?.length).fill(null)
    );
    const isAnyFieldEmpty = selectVariaveis?.length !== valueTreeSelect?.length;

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];

        if (file) {
            const arrayBuffer = await readFileAsArrayBuffer(file);
            setEncriptarArquivo({
                name: file.name,
                data: new Uint8Array(arrayBuffer),
            });
            setFileName(file.name);
        }
    };

    const readFileAsArrayBuffer = (file: File): Promise<ArrayBuffer> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                if (e.target?.result instanceof ArrayBuffer) {
                    resolve(e.target.result);
                }
            };
            reader.readAsArrayBuffer(file);
        });
    };

    function handleChange(html: string) {
        setConvertedText({ editorHtml: html });
    }

    const handleChangeValueSelected = (value: any, index: number) => {
        const newSelectedValues = [...(valueTreeSelect ?? [])];
        newSelectedValues[index] = value;
        setValueTreeSelect(newSelectedValues);
    };

    const removeHtmlTags = (htmlString: string): string => {
        const doc = new DOMParser().parseFromString(htmlString, "text/html");
        return doc.body.textContent || "";
    };

    const extractValuesInsideBraces = (text: string) => {
        const regex = /\{\{(\d+)\}\}/g;
        const matches = text.match(regex);
        if (matches) {
            return matches.map((match) => {
                const numberMatch = match.match(/\d+/);
                return numberMatch ? numberMatch[0] : "";
            });
        }
        return [];
    };

    const {
        value: obterTemplateMensagemAtiva,
        execute: ObterTemplateMensagemAtiva,
    } = useAsyncEffect(
        () => ObterTemplateMensagemAtivaController(Number(idDocumentoTemplate)),
        [idDocumentoTemplate]
    );
    const [convertedText, setConvertedText] = useState<htmlQuill>({
        editorHtml: obterTemplateMensagemAtiva?.DS_CONTEUDO_TEMPLATE ?? "",
    } as htmlQuill);

    const [encriptarArquivo, setEncriptarArquivo] = useState<IFile | undefined>(
        {
            data: new Uint8Array(),
            name:
                obterTemplateMensagemAtiva?.LST_VARIAVEIS_TEMPLATE?.find(
                    (lst) => lst.DS_LOCAL_VALOR.includes("docs.google.com")
                )?.DS_LOCAL_VALOR ?? "",
        }
    );

    const ThereIsInGoogleDrive =
        obterTemplateMensagemAtiva?.LST_VARIAVEIS_TEMPLATE?.find((lst) =>
            lst.DS_LOCAL_VALOR.includes("docs.google.com")
        )?.DS_LOCAL_VALOR;

    const {
        execute: CadastrarTemplateMensagemAtiva,
        loading: CadastrarTemplateMensagemAtivaLoading,
    } = useAsyncCallback(CadastrarTemplateMensagemAtivaController);

    const {
        execute: EditarTemplateMensagemAtiva,
        loading: EditarTemplateMensagemAtivaLoading,
    } = useAsyncCallback(EditarTemplateMensagemAtivaController);

    const {
        execute: RemoverVariaveilMensagemAtiva,
        loading: RemoverVariaveilMensagemAtivaLoading,
    } = useAsyncCallback(RemoverVariavelMensagemAtivaController);

    function handleCadastrarTemplateMensagemAtivaFormSubmit(
        formData: ICadastroTemplateMensagemAtiva
    ) {
        if (isAnyFieldEmpty) {
            setRequiredMessage(true);
            if(selectVariaveis[0] === "0" && !isImagemAnexada){
                setRequiredMessage(false);
            }
        } else {
            const variaveisTemplate = selectVariaveis?.map(
                (nrPosicao, index) => {
                    const isFileVariable =
                        encriptarArquivo && nrPosicao === "0";

                    return {
                        NR_POSICAO_VARIAVEL: Number(nrPosicao) ?? 0,
                        DS_LOCAL_VALOR:
                            isFileVariable && ThereIsInGoogleDrive
                                ? ThereIsInGoogleDrive
                                : isFileVariable
                                ? ""
                                : String(valueTreeSelect[index]),
                        DS_TIPO_VARIAVEL:
                            isFileVariable && ThereIsInGoogleDrive
                                ? "IMAGE"
                                : isFileVariable
                                ? "IMAGE"
                                : "TEXT",
                        ID_VARIAVEL_TEMPLATE:
                            obterTemplateMensagemAtiva
                                ?.LST_VARIAVEIS_TEMPLATE?.[index]
                                ?.ID_VARIAVEL_TEMPLATE || 0,
                        DS_ARQUIVO: isFileVariable
                            ? Object.values(encriptarArquivo?.data)
                            : undefined,
                        DS_FILE_NAME: isFileVariable ? fileName : "",
                    };
                }
            ) as ILstVariaveistemplate[];

            const templateData = {
                ...formData,
                DS_CONTEUDO_TEMPLATE: removeHtmlTags(convertedText.editorHtml),
                LST_VARIAVEIS_TEMPLATE: variaveisTemplate,
            };

            if (!obterTemplateMensagemAtiva) {
                CadastrarTemplateMensagemAtiva(templateData).then(() => {
                    history.push(
                        ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES.DS_PATH
                    );
                    setRequiredMessage(false);
                });
            } else {
                EditarTemplateMensagemAtiva(
                    Number(idDocumentoTemplate),
                    templateData
                ).then(() => {
                    history.push(
                        ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES.DS_PATH
                    );
                    setRequiredMessage(false);
                });
            }
        }
    }

    const isImagemAnexada = encriptarArquivo && /{{0}}/.test(convertedText.editorHtml); // verifica se existe uma imagem anexada e um {{0}}

    useEffect(() => {
        if (obterTemplateMensagemAtiva?.DS_CONTEUDO_TEMPLATE) {
            setConvertedText({
                editorHtml: obterTemplateMensagemAtiva?.DS_CONTEUDO_TEMPLATE,
            });
            setValueTreeSelect(
                obterTemplateMensagemAtiva?.LST_VARIAVEIS_TEMPLATE?.map(
                    (res) => res.DS_LOCAL_VALOR
                ) ?? []
            );
            setEncriptarArquivo({
                data: new Uint8Array(),
                name:
                    obterTemplateMensagemAtiva?.LST_VARIAVEIS_TEMPLATE?.find(
                        (lst) => lst.DS_LOCAL_VALOR.includes("docs.google.com")
                    )?.DS_LOCAL_VALOR ?? "",
            });
        }
    }, [obterTemplateMensagemAtiva]);

    useEffect(() => {
        const valuesInsideBraces = extractValuesInsideBraces(
            convertedText.editorHtml
        );
        setSelectVariaveis(valuesInsideBraces);
    }, [convertedText.editorHtml]);

    return (
        <div className="w-100 p-4">
            <h4>
                <FontAwesomeIcon
                    icon={!obterTemplateMensagemAtiva ? faPaperPlane : faEdit}
                    className="mr-2"
                    size="lg"
                />
                {!obterTemplateMensagemAtiva
                    ? "Cadastrar Template"
                    : "Editar Template"}
            </h4>
            <hr />
            <FormProvider {...FormMethods}>
                <UnForm
                    handleSubmit={
                        handleCadastrarTemplateMensagemAtivaFormSubmit
                    }
                    className="row"
                    usingContext
                >
                    <div className="row mb-3 d-flex flex-wrap col-12">
                        <div className="col-12 col-md-9">
                            <UnForm.Input
                                name="DS_NOME_TEMPLATE"
                                label="Nome do template"
                                wrapperClassName="col-6"
                                defaultValue={
                                    obterTemplateMensagemAtiva?.DS_NOME_TEMPLATE
                                }
                                registerOptions={{
                                    required: "Insira um nome para o template",
                                    validate: {
                                        required: (value: string) =>
                                            value.trim()
                                                ? true
                                                : "Insira um nome para o template",
                                    },
                                }}
                            />
                        </div>
                        <div
                            className="col-12 col-md-3"
                            style={{ position: "relative" }}
                        >
                            <UnForm.Input
                                name=""
                                label="Inserir imagem"
                                type="file"
                                wrapperClassName="col-6"
                                onChange={handleFileChange}
                                disabled={
                                    !convertedText.editorHtml.includes("{{0}}")
                                }
                                style={{ paddingRight: "30px" }}
                            />
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip">
                                        {`Para permitir a seleção de uma imagem, certifique-se de incluir uma variável {{0}}. Lembre-se de que a opção de imagem está disponível apenas para clientes META.`}
                                    </Tooltip>
                                }
                            >
                                <span
                                    style={{
                                        cursor: "pointer",
                                        position: "absolute",
                                        top: "50%",
                                        marginRight: "15px",
                                        transform: "translateY(-30%)",
                                        right: "5px",
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        className="text-warning"
                                        style={{
                                            height: "20px",
                                            width: "20px",
                                        }}
                                    />
                                </span>
                            </OverlayTrigger>
                        </div>
                        {uploading && (
                            <div className="d-flex align-items-center justify-content-center g-2 p-2">
                                Fazendo upload de imagem{" "}
                                <Spinner size="sm" color="primary" />
                            </div>
                        )}
                        <div className="col-12 col-md-12">
                            <FroalaEditor
                                value={convertedText.editorHtml || ""}
                                onChange={handleChange}
                                onImageUploadStart={() => setUploading(true)}
                                onImageUploadEnd={() => setUploading(false)}
                                setUploadedImages={setUploadedImages}
                            />
                        </div>
                        {selectVariaveis?.map((res, index) => {
                            return (
                                <div
                                    key={index}
                                    className="col-12 col-md-12 mt-2"
                                >
                                    <div className="d-flex align-items-center">
                                        {res !== "0" && (
                                            <>
                                                <span className="d-flex align-items-center mr-1">{`{{${res}}}`}</span>
                                                <Select
                                                    className="w-100 mr-1"
                                                    value={{
                                                        label:
                                                            valueTreeSelect &&
                                                            valueTreeSelect[
                                                                index
                                                            ] !== undefined
                                                                ? mockTemplateHelpdesk
                                                                      .flatMap(
                                                                          (
                                                                              group
                                                                          ) =>
                                                                              group.atributos
                                                                      )
                                                                      .filter(
                                                                          (
                                                                              atr
                                                                          ) =>
                                                                              atr.parametro ===
                                                                              valueTreeSelect[
                                                                                  index
                                                                              ]
                                                                      )
                                                                      .map(
                                                                          (
                                                                              atr
                                                                          ) =>
                                                                              atr.campo
                                                                      )
                                                                      .find(
                                                                          (
                                                                              campo
                                                                          ) =>
                                                                              campo !==
                                                                              undefined
                                                                      )
                                                                : "",
                                                        value:
                                                            valueTreeSelect &&
                                                            valueTreeSelect[
                                                                index
                                                            ] !== undefined
                                                                ? valueTreeSelect[
                                                                      index
                                                                  ]
                                                                : "",
                                                    }}
                                                    onChange={(
                                                        selectedOption
                                                    ) =>
                                                        handleChangeValueSelected(
                                                            selectedOption?.value,
                                                            index
                                                        )
                                                    }
                                                    options={mockTemplateHelpdesk.map(
                                                        (group) => ({
                                                            label: group.displayName,
                                                            options:
                                                                group.atributos.map(
                                                                    (atr) => ({
                                                                        label: atr.campo,
                                                                        value: atr.parametro,
                                                                    })
                                                                ),
                                                        })
                                                    )}
                                                    placeholder="Selecione uma variável"
                                                    isSearchable
                                                    required
                                                />
                                                <button
                                                    className="btn btn-outline-danger"
                                                    onClick={() => {
                                                        Swal.fire({
                                                            title: "Deseja apagar esta variavel?",
                                                            icon: "info",
                                                            buttonsStyling:
                                                                false,
                                                            confirmButtonText:
                                                                "<i class='la la-check'></i> Sim!",
                                                            showCancelButton:
                                                                true,
                                                            cancelButtonText:
                                                                "<i class='la la-thumbs-down'></i> Não",
                                                            customClass: {
                                                                confirmButton:
                                                                    "btn btn-outline-success",
                                                                cancelButton:
                                                                    "btn btn-default",
                                                            },
                                                        }).then((result) => {
                                                            if (
                                                                result.isConfirmed
                                                            ) {
                                                                RemoverVariaveilMensagemAtiva(
                                                                    Number(
                                                                        obterTemplateMensagemAtiva
                                                                            ?.LST_VARIAVEIS_TEMPLATE?.[
                                                                            index
                                                                        ]
                                                                            ?.ID_VARIAVEL_TEMPLATE
                                                                    ) as any
                                                                ).then(() => {
                                                                    ObterTemplateMensagemAtiva();
                                                                    convertedText.editorHtml.replace(
                                                                        `${selectVariaveis?.[index]}`,
                                                                        ""
                                                                    );
                                                                });
                                                            }
                                                        });
                                                    }}
                                                    disabled={
                                                        RemoverVariaveilMensagemAtivaLoading ||
                                                        !obterTemplateMensagemAtiva
                                                            ?.LST_VARIAVEIS_TEMPLATE?.[
                                                            index
                                                        ]?.ID_VARIAVEL_TEMPLATE
                                                    }
                                                    type="button"
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faTrash}
                                                    />
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            );
                        })}

                        {requiredMessage && (
                            <div className="col-12 col-md-12">
                                <span className="text-danger">
                                    Por favor, preencha todos os templates.
                                </span>
                            </div>
                        )}

                        <div className="col-12 col-md-12">
                            <UnForm.SubmitButton
                                icon={
                                    !obterTemplateMensagemAtiva
                                        ? faPaperPlane
                                        : faEdit
                                }
                                color={
                                    !obterTemplateMensagemAtiva
                                        ? "success"
                                        : "primary"
                                }
                                loading={
                                    CadastrarTemplateMensagemAtivaLoading ||
                                    EditarTemplateMensagemAtivaLoading
                                }
                                loadingSize="sm"
                                className="w-50"
                                wrapperClassName="d-flex justify-content-center pt-5"
                                disabled={
                                    CadastrarTemplateMensagemAtivaLoading ||
                                    !convertedText.editorHtml ||
                                    EditarTemplateMensagemAtivaLoading
                                }
                            >
                                {!obterTemplateMensagemAtiva ? (
                                    <span>Cadastrar Template</span>
                                ) : (
                                    <span>Editar Template</span>
                                )}
                            </UnForm.SubmitButton>
                        </div>
                    </div>
                </UnForm>
            </FormProvider>
        </div>
    );
}
